import { Flex, Space, Tag, Typography } from "antd";
import { createStyles } from "antd-style";
import { get } from "lodash";
import { secondsToTime } from "utils/functions";

const useStyle = createStyles(({ css, token }) => {
  return {
    dropDownBody: css`
      background: white;
      width: 350px;
      border-radius: ${token.borderRadiusLG}px;
      padding: 10px;
      box-shadow: ${token.boxShadow};

      .history-list {
        width: 100%;
        max-width: 100%;
        padding-left: 20px;
        box-sizing: border-box;
        padding-top: 10px;
        border-top: 1px solid ${token.colorBorder};
        margin-bottom: 10px;

        .history-item {
          margin-bottom: 5px;
          padding: 5px;
          width: 100%;
          box-sizing: border-box;
          border-radius: ${token.borderRadius}px;
          box-shadow: ${token.boxShadowTertiary};
        }
      }
    `,
  };
});

interface Props {
  schedule: any;
}

const ScheduleDropdown = ({ schedule }: Props) => {
  const { styles } = useStyle();

  return (
    <div className={styles.dropDownBody}>
      <Typography.Title level={5} className="mt-0">
        {get(schedule, "name")}
      </Typography.Title>

      <div className="history-list !pl-0">
        {get(schedule, "days", [])?.map((item: any, i: number) => (
          <div key={i} className="history-item !py-2">
            <Flex justify="space-between" align="center" gap="8px">
              <Typography.Text className="flex-1">{item.day}</Typography.Text>

              <Space>
                <Tag bordered={false} color={"success"}>
                  {secondsToTime(item.enterTime)} -{secondsToTime(item.exitTime)}
                </Tag>{" "}
                {item.breakStartTime && (
                  <Tag bordered={false} color={"error"}>
                    {secondsToTime(item.breakStartTime)} -{secondsToTime(item.breakEndTime)}
                  </Tag>
                )}
              </Space>
            </Flex>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScheduleDropdown;
